import { defineMessages } from 'react-intl';

export default defineMessages({
  product: {
    id: 'shop.cart.columnTitleProduct',
    defaultMessage: 'Product',
  },
  price: {
    id: 'shop.cart.columnTitlePrice',
    defaultMessage: 'Price',
  },
  quantity: {
    id: 'shop.cart.columnTitleQuantity',
    defaultMessage: 'Quantity',
  },
  total: {
    id: 'shop.cart.columnTitleTotal',
    defaultMessage: 'Total',
  },
});
